import type { ComponentProps } from 'react';
import { clsx } from 'clsx';
import { Field, type FieldProps } from './Field';
import { controlClassName, fieldHintId } from './fieldParts';

type TextareaFieldProps = ComponentProps<'textarea'> & Omit<FieldProps, 'children'>;

/** Zone de texte libellée */
export function TextareaField({ id, label, hint, required, error, className, ...textareaProps }: TextareaFieldProps) {
  return (
    <Field id={id} label={label} hint={hint} error={error} required={required}>
      <textarea
        id={id}
        className={clsx(controlClassName, 'py-2', className)}
        aria-invalid={!!error}
        aria-required={required || undefined}
        aria-describedby={hint ? fieldHintId(id) : undefined}
        {...textareaProps}
      />
    </Field>
  );
}
